import { execute_generator } from './index'

export const api_url = process.env.VUE_APP_API_URL

export const get_actuals = (tenant, filter, booking_search, selected_company, selected_type, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/actuals/json?tenant=' + tenant + '&filter=' + filter + '&booking_search=' + booking_search + '&company=' + selected_company + '&type=' + selected_type + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_fasttrak_actuals = (tenant, filter, booking_search, selected_company, selected_type, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/actuals/fasttrak/json?tenant=' + tenant + '&filter=' + filter + '&booking_search=' + booking_search + '&company=' + selected_company + '&type=' + selected_type + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const reprocess_actuals = (tenant, filter, selected_company, selected_type, selected_status, fromDate, toDate) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/actuals/reprocess?tenant=' + tenant + '&filter=' + filter + '&status=' + selected_status + '&company=' + selected_company + '&type=' + selected_type + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_booking_dashboard = (tenant, selected_base, expireHrs, nextHrs) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/booking/dashboard?tenant=' + tenant + "&selected_base=" + selected_base + "&expire_hours=" + expireHrs + "&next_hours=" + nextHrs}
).next()

export const get_booking_feed_history = (tenant, filter, booking_search, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/feed/history?tenant=' + tenant + '&filter=' + filter + '&booking_search=' + booking_search + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_actuals_payroll_summary_report = (tenant, driver, from_date, to_date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/payroll/summary?tenant=' + tenant + '&driver=' + driver  + '&fromDate=' + from_date + '&toDate=' + to_date + '&reprocess=' + reprocess}
).next()

export const get_trip_sheet = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tripsheet?tenant=' + tenant + "&date=" + date}
).next()

export const get_vehicle_maint_summary = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehmaintsummary?tenant=' + tenant}
).next()

export const get_report_history = (tenant, report_type, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/history?tenant=' + tenant + '&reportType=' + report_type + '&date=' + date}
).next()

export const request_report = (tenant, report_type, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/request?tenant=' + tenant + '&reportType=' + report_type + '&date=' + date}
).next()

export const get_actuals_performance_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/performance?tenant=' + tenant + '&date=' + date}
).next()

export const get_actuals_multiday_otp_report = (tenant, base, client, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/multiday/otp?tenant=' + tenant + '&base=' + base + '&client=' + client + '&fromDate=' + fromDate + '&toDate=' + toDate }
).next()

export const get_actuals_mileage_report = (tenant, date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/mileage?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess}
).next()

export const get_actuals_billing_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/billing?tenant=' + tenant + '&date=' + date}
).next()

export const get_actuals_vehicle_report = (tenant, booking_type, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/vehicle?tenant=' + tenant + '&booking_type=' + booking_type + '&date=' + date}
).next()

export const get_smart_route_assignments = (tenant, date, autoselect) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/smart_route_assignments?tenant=' + tenant + '&date=' + date + '&autoselect=' + autoselect}
).next()

export const update_smart_route_assignment = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/smart_route_assignments?tenant=' + tenant}, body
).next()

export const get_cm_vehicle_map_future_data = (tenant, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle_map_future_data?tenant=' + tenant + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const get_otp_report = (tenant, date, routeFilter) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/otp?tenant=' + tenant + '&date=' + date + '&route_filter=' + routeFilter}
).next()

export const get_otp_history = (tenant, fromDate, toDate, routeFilter, tripFilter, stopFilter, vehicleFilter, driverFilter) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/otp/history?tenant=' + tenant + '&fromDate=' + fromDate + '&toDate=' + toDate + '&route_filter=' + routeFilter + '&trip_filter=' + tripFilter + '&stop_filter=' + stopFilter + '&vehicle_filter=' + vehicleFilter + '&driver_filter=' + driverFilter}
).next()

export const get_actuals_driver_payroll_report = (tenant, date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/driverpayroll?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess}
).next()

export const get_hos_by_client_report = (tenant, from, to, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/hoursByClient?tenant=' + tenant + '&fromDate=' + from + '&toDate=' + to + '&reprocess=' + reprocess}
).next()

export const get_actuals_drivers_daily_report = (tenant, date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/driver?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess}
).next()

export const get_actuals_driver_multiday_report = (tenant, tag, driver, from_date, to_date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/driver/multiday?tenant=' + tenant + '&tag=' + tag + '&driver=' + driver + '&fromDate=' + from_date + '&toDate=' + to_date + '&reprocess=' + reprocess}
).next()

export const get_actuals_mileage_by_booking_report = (tenant, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/mileage_by_booking?tenant=' + tenant + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const push_actuals_driver_multiday_to_payroll = (tenant, tag, driver, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/actuals/driver/multiday/push?tenant=' + tenant + '&tag=' + tag + '&driver=' + driver + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const get_vehicle_utilization = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/utilization?tenant=' + tenant + '&date=' + date}
).next()

export const get_driver_utilization = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/driver/utilization?tenant=' + tenant + '&date=' + date}
).next()

export const get_vehicle_calendar = (tenant, hours_offset, date, base, tag) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&date=' + date + '&base=' + base + '&tag=' + tag}
).next()

export const get_vehicle_type_calendar = (tenant, hours_offset, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/type/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_vehicle_map = (tenant, vehicle_id, samsara_vehicle_id, booking_id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/map?tenant=' + tenant + "&vehicleId=" + vehicle_id + "&samsaraVehicleId=" + samsara_vehicle_id + "&bookingId=" + booking_id}
).next()

export const get_vehicle_map_direct = (tenant, vehicle_id, samsara_vehicle_id, booking_id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/map/direct?tenant=' + tenant + "&vehicleId=" + vehicle_id + "&samsaraVehicleId=" + samsara_vehicle_id + "&bookingId=" + booking_id}
).next()

export const get_vehicle_map_driver = (tenant, vehicle_id, samsara_vehicle_id, booking_id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/map/driver?tenant=' + tenant + "&vehicleId=" + vehicle_id + "&samsaraVehicleId=" + samsara_vehicle_id + "&bookingId=" + booking_id}
).next()

export const get_vehicle_track = (tenant, mode, value, interval) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/track?tenant=' + tenant + "&mode=" + mode + "&value=" + value + "&interval=" + interval}
).next()

export const get_vehicle_trip_history = (tenant, value, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/trip/history?tenant=' + tenant + "&vehicle=" + value + "&fromDate=" + fromDate}
).next()

export const get_vehicle_route_history = (tenant, route_name, vehicle_id, fromDate, minutesBuffer) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/route/history?tenant=' + tenant + "&route_name=" + route_name + "&vehicle=" + vehicle_id + "&fromDate=" + fromDate + "&minutesBuffer=" + minutesBuffer}
).next()

export const get_vehicle_route_locations = (tenant, routeID, minutesBuffer) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/route/locations?tenant=' + tenant + "&routeID=" + routeID + "&minutesBuffer=" + minutesBuffer}
).next()

export const get_vehicle_list = (tenant, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicles/list?tenant=' + tenant + "&fromDate=" + fromDate}
).next()

export const get_route_list = (tenant, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/routes/list?tenant=' + tenant + "&fromDate=" + fromDate}
).next()

export const get_route_names = (tenant, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/routes/names?tenant=' + tenant + "&fromDate=" + fromDate}
).next()

export const get_route_patterns = (tenant, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/routes/patterns?tenant=' + tenant + "&fromDate=" + fromDate}
).next()

export const get_manage_drivers_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/drivers/manage/list?tenant=' + tenant}
).next()

export const get_driver_usernames_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/drivers/usernames/list?tenant=' + tenant}
).next()

export const get_tag_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tags/list?tenant=' + tenant}
).next()

export const get_yard_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/yards/list?tenant=' + tenant}
).next()

export const get_vehicle_track_fleet = (tenant, mode, value) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/track/fleet?tenant=' + tenant + "&mode=" + mode + "&value=" + value}
).next()

export const get_vehicle_track_reload = (tenant, mode, value) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/track/reload?tenant=' + tenant + "&mode=" + mode + "&value=" + value}
).next()

export const get_bus_tracker_results = (tenant, departureDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/bustracker?tenant=' + tenant + "&departureDate=" + departureDate}
).next()

export const get_bus_tracker_status = (tenant, departureDate, routeName, departureTime, departingFrom, arrivingAt) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicle/bustracker/status?tenant=' + tenant + "&departureDate=" + departureDate + "&routeName=" + routeName + "&departureTime=" + departureTime + "&departingFrom=" + departingFrom + "&arrivingAt=" + arrivingAt}
).next()

export const get_admin_dashboard = (tenant, date, tenant_filter,) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/admin/dashboard?tenant=' + tenant + '&date=' + date + '&tenant_filter=' + tenant_filter}
).next()

export const get_tenant_dashboard = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tenant/dashboard?tenant=' + tenant + '&date=' + date}
).next()

export const get_all_tenants_config = () => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tenant/config/all'}
).next()

export const get_tenant_config_history = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tenant/config/history?tenant=' + tenant + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const register_tenant = (config) => execute_generator(
    'POST',{ service: api_url, resource: 'bookings/tenant/register'}, config).next()

export const update_tenant_config_settings = (tenant, config) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/config/settings?tenant=' + tenant}, config).next()

export const get_tenant_config_settings = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/tenant/config/settings?tenant=' + tenant}
).next()
    
export const get_alerts = (tenant, alertType, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/alerts?tenant=' + tenant + '&alertType=' + alertType + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const get_hos_history = (tenant, driver, eventType, remarks_filter, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/hos/history?tenant=' + tenant + '&driver=' + driver + '&eventType=' + eventType + '&remarksFilter=' + remarks_filter + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const get_booking_file_history = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/file/history?tenant=' + tenant + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const send_event_notes_payroll_category_reports = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/event/notes/payrollcategoryreports?tenant=' + tenant + '&startDate=' + startDate
            + '&endDate=' + endDate}
).next()

export const get_event_notes = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/event/notes?tenant=' + tenant + '&startDate=' + startDate
            + '&endDate=' + endDate}
).next()

export const get_vehicle_info = (tenant, base, tag, return_mode) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicles?tenant=' + tenant + '&base=' + base + '&tag=' + tag + '&returnMode=' + return_mode}
).next()

export const get_vehicle_info_fasttrak = (tenant, base, tag, return_mode) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicles/fasttrak?tenant=' + tenant + '&base=' + base + '&tag=' + tag + '&returnMode=' + return_mode}
).next()

export const get_vehicle_info_history = (tenant, vehicleName) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/vehicles/history?tenant=' + tenant + '&vehicleName=' + vehicleName}
).next()

export const get_vehicle_status_history = (tenant, tagName, vehicleName, filter, statusFilter, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/reports/vehiclestatus/history?tenant=' + tenant + '&tagName=' + tagName + '&vehicleName=' + vehicleName + '&filter=' + filter + '&statusFilter=' + statusFilter +'&startDate=' + startDate
            + '&endDate=' + endDate}
).next()

export const reprocess_alerts_for_booking = (tenant, alert_type, booking_hash ) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/alerts/reprocess?tenant=' + tenant + '&alertType=' + alert_type + '&bookingID=' + booking_hash }
).next()

export const test_html_alert = (tenant, alert_type ) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/alerts/test/email/template?tenant=' + tenant + '&alertType=' + alert_type }
).next()

export const save_booking_notes = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/notes?tenant=' + tenant}, body
).next()

export const save_event_notes = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/event/notes?tenant=' + tenant}, body
).next()

export const update_vehicle_status = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/vehicles?tenant=' + tenant}, body
).next()


export const delete_vehicle_status = (tenant, body) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/vehicles?tenant=' + tenant}, body
).next()

export const update_vehicle_status_anonymous = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/vehicles/anonymous?tenant=' + tenant}, body
).next()

export const get_sos_history = (tenant, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/sos/history?tenant=' + tenant + '&startDate=' + startDate
            + '&endDate=' + endDate}
).next()

export const get_sos_details = (tenant, request_id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/sos/' + request_id + '?tenant=' + tenant}
).next()

export const send_sos_request = (tenant, vehicle_name, request_notes) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/sos/send?vehicle_name=' + vehicle_name + '&request_notes=' + request_notes + '&tenant=' + tenant}
).next()

export const delete_sos_request = (tenant, request_id) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/sos/' + request_id + '?tenant=' + tenant}
).next()

export const delete_booking = (tenant, booking_id) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/' + booking_id + '?tenant=' + tenant}
).next()

export const delete_tenant = (tenant) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/' + tenant}
).next()

export const delete_yard = (tenant, yard_name) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/yard?yard_name=' + yard_name + '&tenant=' + tenant}
).next()

export const add_yard = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/yard?tenant=' + tenant}, body
).next()

export const add_hos_event = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/hos/event?tenant=' + tenant}, body
).next()

export const delete_hos_event = (tenant, event_name) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/hos/event?event_name=' + event_name + '&tenant=' + tenant}
).next()

export const add_vehicle_late_alert_event = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/vehiclelatealert/event?tenant=' + tenant}, body
).next()

export const delete_vehicle_late_alert_event = (tenant, event_name) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/vehiclelatealert/event?event_name=' + event_name + '&tenant=' + tenant}
).next()

export const add_cust_event = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/tenant/cust/event?tenant=' + tenant}, body
).next()

export const delete_cust_event = (tenant, event_name) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/tenant/cust/event?event_name=' + event_name + '&tenant=' + tenant}
).next()

export const cancel_sos_request = (tenant, request_id) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/sos/' + request_id + '/cancel?tenant=' + tenant}
).next()

export const get_users = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/users/list?tenant=' + tenant}
).next()

export const get_driver_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/drivers/list?tenant=' + tenant}
).next()

export const get_support_tickets = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/support_tickets/list?tenant=' + tenant}
).next()

export const search_support_tickets = (tenant, assigned, category, priority, subject, ticket_status, startDate, endDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/support_tickets/search?tenant=' + tenant + '&assigned=' + assigned + '&category=' + category + '&priority=' + priority + '&subject=' + subject + '&ticket_status=' + ticket_status + '&startDate=' + startDate + '&endDate=' + endDate}
).next()

export const get_support_ticket = (tenant, id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/support_ticket?tenant=' + tenant + '&id=' + id}
).next()

export const get_route_addresses = (tenant, route_group, route_filter) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/route/addresses?tenant=' + tenant + '&routeGroup=' + route_group + '&routeFilter=' + route_filter}
).next()

export const get_route_assignments = (tenant, route_filter, targetDate) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/route/assignments?tenant=' + tenant + '&routeFilter=' + route_filter + '&targetDate=' + targetDate}
).next()

export const get_groupsender_user_list = (tenant, user_type, driverStartTime, driverEndTime) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/groupsender/users?tenant=' + tenant + '&userType=' + user_type + '&driverStartTime=' + driverStartTime + '&driverEndTime=' + driverEndTime}
).next()

export const send_message_to_group = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/groupsender/send?tenant=' + tenant}, body
).next()

export const send_message_to_user = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/groupsender/senduser?tenant=' + tenant}, body
).next()

export const get_process_manager_list = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/processmgr/list?tenant=' + tenant}
).next()

export const update_process_enabled = (tenant, processId, enabled) => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/processmgr/' + processId + '?tenant=' + tenant + '&enabled=' + enabled}
).next()

export const disable_all_processes = () => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/processmgr/disable_all'}
).next()

export const enable_all_processes = () => execute_generator(
    'PATCH', { service: api_url, resource: 'bookings/processmgr/enable_all'}
).next()

export const delete_process_record = (tenant, processId) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/processmgr/' + processId + '?tenant=' + tenant}
).next()

export const get_user = (tenant, username) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/users/' + username + '?tenant=' + tenant}
).next()

export const get_driver = (tenant, id) => execute_generator(
    'GET', { service: api_url, resource: 'bookings/drivers/' + id + '?tenant=' + tenant}
).next()

export const delete_user = (tenant, username) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/users/' + username + '?tenant=' + tenant}
).next()

export const create_user = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/users?tenant=' + tenant}, body
).next()

export const update_user = (tenant, body) => execute_generator(
    'PUT', { service: api_url, resource: 'bookings/users?tenant=' + tenant}, body
).next()

export const update_driver = (tenant, body) => execute_generator(
    'PUT', { service: api_url, resource: 'bookings/drivers?tenant=' + tenant}, body
).next()

export const create_support_ticket = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/support_ticket?tenant=' + tenant}, body
).next()

export const update_support_ticket = (tenant, body, send_email) => execute_generator(
    'PUT', { service: api_url, resource: 'bookings/support_ticket?tenant=' + tenant + '&send_email=' + send_email}, body
).next()

export const delete_support_ticket = (tenant, ticket_id) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/support_tickets/' + ticket_id + '?tenant=' + tenant}
).next()

export const create_support_ticket_comment = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'bookings/support_ticket/comment?tenant=' + tenant}, body
).next()

export const update_support_ticket_comment = (tenant, body) => execute_generator(
    'PUT', { service: api_url, resource: 'bookings/support_ticket/comment?tenant=' + tenant}, body
).next()

export const delete_support_ticket_comment = (tenant, body) => execute_generator(
    'DELETE', { service: api_url, resource: 'bookings/support_ticket/comment?tenant=' + tenant}, body
).next()
